import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M15.75,4.8h-7.5V2.798C8.25,2.249,8.671,1.8,9.189,1.8h5.623c0.518,0,0.938,0.449,0.938,0.998V4.8z"/>' +
        '<path d="M18.563,2.8h-1.875v2.852H7.315V2.8H5.44C4.921,2.8,4.5,3.229,4.5,3.751v17.1c0,0.521,0.421,0.949,0.94,0.949h13.122' +
        'c0.517,0,0.938-0.428,0.938-0.949v-17.1C19.5,3.229,19.079,2.8,18.563,2.8z M16.249,19.944h-8.5v-1h8.5V19.944z M16.249,18.038' +
        'h-8.5v-1h8.5V18.038z M7.749,10.877c0-0.52,0.424-0.946,0.943-0.946h1.891V8.042c0-0.52,0.425-0.941,0.945-0.941h0.942' +
        'c0.522,0,0.948,0.422,0.948,0.941v1.889h1.888c0.517,0,0.942,0.427,0.942,0.946v0.944c0,0.516-0.426,0.942-0.942,0.942h-1.888' +
        'v1.892c0,0.518-0.425,0.945-0.948,0.945h-0.942c-0.521,0-0.945-0.428-0.945-0.945v-1.892H8.692c-0.519,0-0.943-0.427-0.943-0.942' +
        'V10.877z"/>',
    }
  },
}